<template>
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <g id="gitlab" fill-rule="nonzero">
      <g class="fill-current text-gray-600" transform="translate(1.427385, 0.056264)">
        <polygon
          points="10.5660162 22.0114447 14.965779 8.47039892 6.16657682 8.47039892 10.5661456 22.0114447"
        ></polygon>
        <path
          d="M6.4690027e-05,8.47039892 L6.16631806,8.47039892 L3.51622642,0.314733154 C3.37992453,-0.104911051 2.78626415,-0.104911051 2.65002695,0.314733154 L1.15463195e-14,8.47039892 L6.4690027e-05,8.47039892 Z"
        ></path>
        <path
          d="M21.1319677,8.47039892 L14.9657143,8.47039892 L17.6158059,0.314733154 C17.7521725,-0.104911051 18.3458329,-0.104911051 18.4821348,0.314733154 L21.1320323,8.47039892 L21.1319677,8.47039892 Z"
        ></path>
      </g>
      <g class="fill-current text-gray-500" transform="translate(1.427385, 8.526663)">
        <polygon
          points="10.5660162 13.5410458 6.16625337 3.55271368e-15 1.0658141e-14 3.55271368e-15 10.5661456 13.5409164"
        ></polygon>
        <polygon
          points="10.5660162 13.5410458 14.965779 3.55271368e-15 21.1320323 3.55271368e-15 10.5661456 13.5409164"
        ></polygon>
      </g>
      <g class="fill-current text-gray-400" transform="translate(0.045694, 8.526598)">
        <path
          d="M1.38175652,-3.55271368e-14 L0.0446136664,4.1149973 C-0.0772623444,4.49039353 0.0562578713,4.90162803 0.375632534,5.13347709 L11.947708,13.5411105 L1.38175652,-3.55271368e-14 L1.38175652,-3.55271368e-14 Z"
        ></path>
        <path
          d="M22.5136595,-3.55271368e-14 L23.8508023,4.1149973 C23.9726784,4.49039353 23.8391581,4.90162803 23.5197835,5.13347709 L11.947708,13.5411105 L22.5136595,-3.55271368e-14 L22.5136595,-3.55271368e-14 Z"
        ></path>
      </g>
    </g>
  </svg>
</template>
